import { ITranslation } from "./types";

export const de: ITranslation = {
  messageFallbacks: {
    homeOrderNotReadyMsg:
      'Vielen Dank für deinen Einkauf! Dein Kassenbon ist noch in Bearbeitung, bitte komme in einige Zeit wieder zurück! <br/>In case of any issues, please reach out through venue support.',
    errorReachOutSupportMsg:
      'In case of any issues, please reach out through venue support.',
  },
  api: {
    E_FORCED_LOGOUT:
      "Sie wurden abgemeldet, da Ihre Verbindung abgelaufen ist.",
  },
  orderStatus: {
    draft: "Entwurf",
    contested: "Reklamiert",
    paid: "Bezahlt",
    unpaid: "Unbezahlt",
    pending: "Ausstehend",
    reviewed: "Überprüft",
    paymentProcessing: "Zahlungsabwicklung",
    refunded: "Rückerstattet",
    unknown: "Unbekannt",
  },
  receiptsList: {
    headings: {
      date: "Datum",
      time: "Zeit",
      status: "Status",
      total: "Total",
    },
    action: {
      view: "Anschauen",
    },
    statusTooltip: {
      draft: "Entwurf - Kassenbeleg wird derzeit erstellt",
      paid: "Bezahlt - Kassenbeleg wurde erstellt und Zahlung ist abgeschlossen",
      paymentProcessing:
        "Zahlungsabwicklung - Kassenbeleg wurde erstellt und Zahlungsvorgang wurde gestartet",
      unpaid:
        "Unbezahlt - Kassenbeleg wurde erstellt aber Zahlung konnte nicht erfolgreich abgeschlossen werden",
      pending:
        "Ausstehend - Kassenbeleg wurde durch Kunden reklamiert und ist derzeit beim Händler in Bearbeitung",
      reviewed:
        "Geprüft - Kassenbeleg wurde durch Kunden reklamiert und der Händler hat die Überprüfung abgeschlossen",
    },
    loadMore: "Mehr laden",
    loadingMore: "Lädt...",
    showing: "Anzeigen",
  },
  receiptDetailScreen: {
    headerTitle: "Beleg Details",
    subtotal: "Nettosumme:",
    taxBreakdown: {
      headers: {
        rate: "Steuer %",
        netto: "Netto",
        brutto: "Brutto",
        tax: "Steuer",
        total: "Gesamtbetrag:",
      },
    },
    tax: "Steuer",
    taxCRV: "CRV",
    total: "Summe:",
    processTime: "Bearbeitungszeit",
    date: "Datum",
    listOfProducts: "Artikelauflistung:",
    paymentStatus: "Zahlungsstatus:",
    orderId: "Bon-Nummer:",
  },
  receiptDetailComplain: {
    reportProblem: "Problem melden",
    submitReview: "Zur Überprüfung einsenden",
    confirmTitle: "Beleg gesendet",
    confirmButton: "Fertig",
    addMissingItem: "Produkt hinzufügen",
    addMissingItemMessage: "Eine Nachricht hinzufügen (optional)",
    form: {
      email: {
        label: "Wie können wir Sie kontaktieren?",
        placeholder: "Ihre E-Mail, z. B. me@example.com",
        errors: {
          required: "E-Mail-Adresse ist erforderlich.",
          isEmail: "Ungültige E-Mail-Adresse.",
          inUse: "E-Mail-Adresse wird bereits verwendet.",
        },
      },
    },
  },
  receiptsScreen: {
    label: {
      contested: "in Überprüfung",
      draft: "Entwurf",
      empty: "Leer",
      paid: "Bezahlt",
      pending: "Ausstehend",
      refunded: "Rückerstattet",
      reviewed: "Überarbeitet",
      unknown: "Unbekannt",
      unpaid: "Unbezahlt",
      paymentProcessing: "Zahlungsabwicklung",
    },
    message: {
      contested: "in Überprüfung Nachricht",
      draft: "Entwurf der Nachricht",
      empty: "Leere Nachricht",
      paid: "Bezahlte Nachricht",
      pending: "Ausstehende Nachricht",
      refunded: "Rückerstattungsnachricht",
      reviewed: "Überprüfte Nachricht",
      unpaid: "Unbezahlte Nachricht",
      paymentProcessing: "Zahlungsabwicklung",
    },
    minutes: "Minuten",
    hours: "Std",
    days: "Tage",
  },
  slideModal: {
    close: "Schließen",
    searchPlaceholder: "Artikel suchen",
  },
  receiptsHome: {
    receiptPortal: "Kassenbeleg-Portal",
    selectPaymentType:
      "Wähle die Zahlungsmethode, mit der du den Store betreten hast",
    selectPaymentTypeSubtitle: "Wenn Sie Ihr Telefon oder Ihre Smartwatch verwendet haben, wählen Sie Apple Pay oder Google Pay",
    cardBin:
      "Die ersten %{cardBinDigitsCount} Ziffern der Kreditkartennummer (BIN/IIN)",
    last4: "Die letzten 4 Ziffern der Kreditkartennummer",
    last4Apple: "Die letzten 4 Ziffern deiner Apple Pay-Kartenummer",
    last4Google: "Die letzten 4 Ziffern deiner Google Pay-Kartennummer",
    instructionApple:
      "Finde die letzten 4 Ziffern deiner Apple Pay-Kartennummer in deinem Apple Wallet und gib sie unten ein",
    openWallet: "Apple Wallet öffnen",
    instructionGoogle:
      "Finde die letzten 4 Ziffern deiner Google Pay-Kartennummer in deinem Google Wallet und gib sie unten ein",
    instructionExternalId:
      "Finden Sie die Zahlungsreferenznummer in Ihrer Zahlungs-App oder Ihrem Kontoauszug.",
    externalIdLabel: "Zahlungsreferenznummer",
    externalIdPlaceholder: "",
    expDate: "Ablaufdatum der Kreditkarte",
    visitDate: "Datum deines Besuchs",
    submit: "Quittungen zeigen",
    registerEmail:
      "Bitte gib deine E-Mail-Adresse ein, um in Kürze deinen Kassenbeleg per E-Mail zu erhalten",
    registerEmailSuccess: "E-mail Adresse ist erfolgreich registriert.",
    registerEmailFail:
      "E-mail Adress ist nicht registriert weil es leider keine Kassenbon verknüpft ist mit die eingegebene Kartennummer und/oder Einkaufsdatum.",
    unrecognizedError: "Ein unerkannter Fehler ist aufgetreten",
    inconclusiveCardInfo: "Wir können deinen Kassenbeleg nicht finden",
    optionalFieldPlaceholder: "Optional",
    invalidCaptcha: "Ungültiges Captcha, bitte versuche es erneut",
    oasisApiError:
      "Wir konnten keine Verbindung zum Kassenbeleg-Server herstellen. Bitte versuche es später erneut.",
    orderNotFound: "Bestellung nicht gefunden",
  },
  receiptError: {
    notFound: {
      title: "Kassenbeleg nicht gefunden",
      message: "Wir konnten keinen Kassenbeleg für diese Bestellung finden. Er ist möglicherweise abgelaufen, wurde entfernt oder der Link ist falsch.",
      retry: "Erneut versuchen",
      contactSupport: "Support kontaktieren",
      goBack: "Zurück",
    },
    serverError: {
      title: "Etwas ist schief gelaufen",
      message: "Das liegt an uns. Bitte versuchen Sie es in einem Moment erneut. Wenn es weiterhin passiert, kontaktieren Sie unser Support-Team.",
      retry: "Erneut versuchen",
      contactSupport: "Support kontaktieren",
    },
  },
  notFound: {
    title: "Seite nicht gefunden",
    message: "Etwas ist schief gelaufen oder der Link ist falsch.",
    goHome: "Zur Startseite",
    goBack: "Zurück",
  },
};
